import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Landing Page
 * 
 * the root page of the application
 * @returns 
 */
export default function LandingPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/login");
  }, []); // eslint-disable-line
  return <></>;
}
